import { isMobile } from '../../../constants';

export const MESSAGE_MIN_LENGTH = 50;
export const MESSAGE_MAX_LENGTH = 10000;

export enum CustomExamCenters {
  CODENGO = 'Codengo',
  LA_POSTE = 'La Poste',
  SGS = 'SGS',
  DEKRA = 'Dekra',
}

export const CUSTOM_EXAM_CENTERS: string[] = Object.values(CustomExamCenters);

export enum DrivingSchoolsType {
  TRADITIONAL = 'traditional',
  ONLINE = 'online',
  NONE = 'none',
}

export const DRIVING_SCHOOLS_OPTIONS = [
  {
    label: 'Traditionnelle',
    value: DrivingSchoolsType.TRADITIONAL,
  },
  {
    label: 'En\xa0ligne',
    value: DrivingSchoolsType.ONLINE,
  },
  {
    label: isMobile ? 'Pas\xa0inscrit' : 'Je\xa0ne\xa0suis\xa0pas\xa0inscrit',
    value: DrivingSchoolsType.NONE,
  },
];

export const HELP_SEARCH_OPTIONS = [
  {
    label: 'Oui, ça m’intéresse !',
    value: '1',
  },
  {
    label: 'Non merci',
    value: '0',
  },
];
